
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as testmjie3NLwVY9BVbH2l3udVLh_7hYm5EehxOtPSq1_BzIMeta } from "/opt/buildhome/repo/pages/zapo/test.vue?macro=true";
import { default as loginwro5JqY_h5KW7eQAaFtLac9N8BWQRX9jADT3dnAvGxgMeta } from "/opt/buildhome/repo/pages/auth/login.vue?macro=true";
import { default as forgotZiB9PFgVp3dsJGRGY0_lSlvZcygPWoD9gKz7KEx_45eYkMeta } from "/opt/buildhome/repo/pages/auth/forgot.vue?macro=true";
import { default as register5lTphtFRNlFlSjuk4VxUGViZtUArcbdveTqy_Rl6yR8Meta } from "/opt/buildhome/repo/pages/auth/register.vue?macro=true";
import { default as calls9P5xsrL3BEJJpZu8mYXSo54WxsW_tWuFMtzkTnk53m4Meta } from "/opt/buildhome/repo/pages/customer/calls.vue?macro=true";
import { default as inbox8kmABmNvfq4HyOIcCQfpgqcHRwubIzzQdGvMnuUOqKkMeta } from "/opt/buildhome/repo/pages/customer/inbox.vue?macro=true";
import { default as leadsaUfmXLw_45TmY_MtxPnD6BrDyTJtbR9XCRsFfBZYU5IEQMeta } from "/opt/buildhome/repo/pages/customer/leads.vue?macro=true";
import { default as tasksDH0EE2DPR849pbQuWvQz5log72ic6dH9LHNEnkxHmTYMeta } from "/opt/buildhome/repo/pages/customer/tasks.vue?macro=true";
import { default as _3_45planT9lwBZ2QHFxXEZlsoYAMs5xrpduTB7UR_1QAey23hREMeta } from "/opt/buildhome/repo/pages/sign-up/3-plan.vue?macro=true";
import { default as eventsYzWOnOLmYgiRrB5iPTEZhgDYM906f8UA_45pb1NEKguugMeta } from "/opt/buildhome/repo/pages/customer/events.vue?macro=true";
import { default as onboarding_45KL_45d9M1l7kl2HVNbYyQ9ejmcmgapPLxlecjtCQCMTwMeta } from "/opt/buildhome/repo/pages/zapo/onboarding.vue?macro=true";
import { default as useryrKyatMNInJPJTBVE0bXuzdegS0FrTwMM72jiYVdFWYMeta } from "/opt/buildhome/repo/pages/zapo/tools/user.vue?macro=true";
import { default as adsejd_ST8MKo1_CqWyndyK9j_45mqe1TnQQ2V_8Z2Ur7CygMeta } from "/opt/buildhome/repo/pages/zapo/company/ads.vue?macro=true";
import { default as mrrV5bfWwoH6mrYZlfphahOafwvux0v93RurWg5L8AkYQIMeta } from "/opt/buildhome/repo/pages/zapo/reports/mrr.vue?macro=true";
import { default as leadsri5BjdTEEPgktDDOklOQRcT9Vx89grDyHexdYBxSqu4Meta } from "/opt/buildhome/repo/pages/zapo/sales/leads.vue?macro=true";
import { default as users0ThgEugISU_454ZyxFhFy2qa_hGeVZ6vGOAE383iNLU7oMeta } from "/opt/buildhome/repo/pages/zapo/tools/users.vue?macro=true";
import { default as calendarY7UQIblU3pyfSc3OD2m9_45sltVxoEuyF3PWSfRfkqpIgMeta } from "/opt/buildhome/repo/pages/customer/calendar.vue?macro=true";
import { default as _1_45companyqYPAkkJPyN8kivkYCo7qnrZFieJrWgTxtNZEimXVYKsMeta } from "/opt/buildhome/repo/pages/sign-up/1-company.vue?macro=true";
import { default as _4_45paymentuZjiXxeDz64a5PfbDCtfwmUnJYQCh5TooJTwfunxxGQMeta } from "/opt/buildhome/repo/pages/sign-up/4-payment.vue?macro=true";
import { default as landing_45page7voWyH9oqunwZTphKlZ86Ci_FiMteDAN1qNh2zFq42EMeta } from "/opt/buildhome/repo/pages/zapo/landing-page.vue?macro=true";
import { default as dealXzj_0IE5LK7CFozQynjdWIH3Xx6WUysVd1x_454Z6XITMMeta } from "/opt/buildhome/repo/pages/customer/deal/deal.vue?macro=true";
import { default as _4_45build71KE_45Ve33ojf6LRJi_45zA7VmExSgktNI4zdgh30IOgvgMeta } from "/opt/buildhome/repo/pages/onboarding/4-build.vue?macro=true";
import { default as _2_45locationHQBwXL_T1Rug6p06Z2EttFd5nFJ_45tFjYEkPtojsxkowMeta } from "/opt/buildhome/repo/pages/sign-up/2-location.vue?macro=true";
import { default as _5_45completeU2oeAQ_455lrSojmsD0a7cGQmFzU_iXkEbD_45pnKG3Q8boMeta } from "/opt/buildhome/repo/pages/sign-up/5-complete.vue?macro=true";
import { default as aboutTd1J2W_WbmmyZ_45kwKBlsOp4BUx1IkEu1QOuOYnQfWe4Meta } from "/opt/buildhome/repo/pages/zapo/company/about.vue?macro=true";
import { default as cardsh9LPhkyHZ6T5gOuFL3RMmRuAOo1cL_45jp1tDElPgRyW8Meta } from "/opt/buildhome/repo/pages/zapo/company/cards.vue?macro=true";
import { default as index0Dtox6n_45ZqcoqdgMB_U8laBgyAKQw8YCh32MwF6lkJ8Meta } from "/opt/buildhome/repo/pages/zapo/company/index.vue?macro=true";
import { default as callsfK62a3Ux8FyFHMtXqicUGJudIxDKLey4lTX_45qSrHpoQMeta } from "/opt/buildhome/repo/pages/zapo/reports/calls.vue?macro=true";
import { default as domainsmdOI_45yTAEf2XSpsoTl2zBgaWsDdUIkS2dQOeSXFtepMMeta } from "/opt/buildhome/repo/pages/zapo/tools/domains.vue?macro=true";
import { default as dealsXblHRNROVxxIjMqu_oaOLb1jMWdP3xJ3dPzlUQodbSUMeta } from "/opt/buildhome/repo/pages/customer/deal/deals.vue?macro=true";
import { default as _2_45imageshRrjf_45EM32PkOzxa9h8dMm_45SMHNX4nxvW5iTjLwGFP0Meta } from "/opt/buildhome/repo/pages/onboarding/2-images.vue?macro=true";
import { default as _5_45launchiAu1laZ_45ADz8r5tDsN96CO9vL_0kz2j5sXshGAVYeRAMeta } from "/opt/buildhome/repo/pages/onboarding/5-launch.vue?macro=true";
import { default as assetsKOfMglQqMfoCtrO3bCIuryoGthOKgh_45FXvH7HyMkeggMeta } from "/opt/buildhome/repo/pages/zapo/company/assets.vue?macro=true";
import { default as veriffOXgWRi_45B0F0JOJHd4KrJ1Pebicbe0o9OpSA36y0h_jQMeta } from "/opt/buildhome/repo/pages/zapo/company/veriff.vue?macro=true";
import { default as companyhSUrtdxFZ8OsgVfXlWv0IXd9VdaChpSmhwbFCBiUsPQMeta } from "/opt/buildhome/repo/pages/zapo/company/company.vue?macro=true";
import { default as sign_45upRPRbmSF5gUjfSXK7HDpyxTCTc3rWrd9RABTA7Lf5N_oMeta } from "/opt/buildhome/repo/pages/zapo/company/sign-up.vue?macro=true";
import { default as prospectsVtwM9A_jLxdZJB3iyc1ls0jX2s_45v_QsqG1Nq8sZSnioMeta } from "/opt/buildhome/repo/pages/zapo/sales/prospects.vue?macro=true";
import { default as locationsNJPK9cSxwuETBCcxa05HAYw2aARx7VdEA3cqkk_zXjAMeta } from "/opt/buildhome/repo/pages/zapo/tools/locations.vue?macro=true";
import { default as sms_45verificationSfPewR1ocbvTIXWguTvlmLcfdsWAXSSZ1weNpFKFfoUMeta } from "/opt/buildhome/repo/pages/auth/sms-verification.vue?macro=true";
import { default as _1_45business_2AWsxrTksOaNBcFO_oiPygB2hohSvfxmon5Snisf_wMeta } from "/opt/buildhome/repo/pages/onboarding/1-business.vue?macro=true";
import { default as invoiceso__45YeSqTNGBLBafBfgC0Of2i2tSPaAiDNPd4SQfoWO4Meta } from "/opt/buildhome/repo/pages/zapo/company/invoices.vue?macro=true";
import { default as notificationsSfVceBGsQpNjHgO_JgE45dgW9rDwdp_45zFHb9llNC8ekMeta } from "/opt/buildhome/repo/pages/customer/notifications.vue?macro=true";
import { default as lead_45feed1Hbuc2jbjndKjyjqQ_45SyBrxoWaxEkMWeqQ88Ay__45rQYMeta } from "/opt/buildhome/repo/pages/zapo/reports/lead-feed.vue?macro=true";
import { default as email_45verificationEujvUzarG61vGoEQpb9CjUAJJW9xPFrdA41hX_p8BQgMeta } from "/opt/buildhome/repo/pages/auth/email-verification.vue?macro=true";
import { default as users3gBq4_RwQzzQUU6zqEggVTNRpX_cNB0PSA8sMT4U38oMeta } from "/opt/buildhome/repo/pages/customer/settings/users.vue?macro=true";
import { default as onboardingrNfBdbgXvQOEPsCiZxFtsqlPpxe5aYSdptG6GjSbszkMeta } from "/opt/buildhome/repo/pages/zapo/company/onboarding.vue?macro=true";
import { default as commissionNlC_8gYBWUflS0oeKYWC7mqb9ta3zz432Y2ZrUpFk0gMeta } from "/opt/buildhome/repo/pages/zapo/reports/commission.vue?macro=true";
import { default as salesboardRQ_ATV_7fXHXDxJupZAgNpu_45OprK3wM6UJWmAFszGukMeta } from "/opt/buildhome/repo/pages/zapo/reports/salesboard.vue?macro=true";
import { default as lead_45qualityyj26punnSynrvRO3FkYVTrqWw4swy_459Yfs_z2Ni9O9EMeta } from "/opt/buildhome/repo/pages/zapo/tools/lead-quality.vue?macro=true";
import { default as search_45termssvLOlALqlODvPpu73vRGQY5csELNEhxDipla6vLc37MMeta } from "/opt/buildhome/repo/pages/zapo/tools/search-terms.vue?macro=true";
import { default as contactrgaF_7tsST_45ATG2bmpMH6Wl_45aEhB5slbX9VgvVaG8F0Meta } from "/opt/buildhome/repo/pages/customer/contact/contact.vue?macro=true";
import { default as dealsqJFXxxLueyUeXYi90owe4OYGlHxMUtz5VwvXw_EQ6PwMeta } from "/opt/buildhome/repo/pages/customer/reporting/deals.vue?macro=true";
import { default as leadsdWRuvqQUItECtwg_r9QYWVMUSKcP4_MoD6pSpSy75kAMeta } from "/opt/buildhome/repo/pages/customer/reporting/leads.vue?macro=true";
import { default as performanceqEwMe2BB7Dl_kIpkb3IfcfontMnfvIjRwTh2ioqP9QsMeta } from "/opt/buildhome/repo/pages/zapo/company/performance.vue?macro=true";
import { default as lead_45volumeub1RaSanEiPJOI3BbgOrrxLE2E4SskLpjF0WXezcc7cMeta } from "/opt/buildhome/repo/pages/zapo/reports/lead-volume.vue?macro=true";
import { default as sms_45templatesZ73e5lLHMmjkh4gl0bK62HVRKBPdQqM6dEg4tyF_45xYcMeta } from "/opt/buildhome/repo/pages/zapo/tools/sms-templates.vue?macro=true";
import { default as contactsCmYlvP1j126ECd_45D6knyG8jsU_456JH_45I9KxVOipMfPtcMeta } from "/opt/buildhome/repo/pages/customer/contact/contacts.vue?macro=true";
import { default as profilefprNIs973sVbZFLqYWIJyKIAC0f0YrbLTgDlKA9JJeEMeta } from "/opt/buildhome/repo/pages/customer/settings/profile.vue?macro=true";
import { default as _3_45verificationKfHUCPm55XZk9IuV2HVgCBubwPBAdBPbL6vnPK6FtbIMeta } from "/opt/buildhome/repo/pages/onboarding/3-verification.vue?macro=true";
import { default as landing_45page_81ChQ_452WZDgGhK0SozLgz1csCAXdM_sGp4YYnARgIIMeta } from "/opt/buildhome/repo/pages/zapo/company/landing-page.vue?macro=true";
import { default as userkIkk9t_45PhkPtZEEVBry5IUNnGVymxSN8kLwVGeNOalsMeta } from "/opt/buildhome/repo/pages/zapo/management/user/user.vue?macro=true";
import { default as system_45optionstYLDiaMEibWjNMi3Qhx7U_45q7pXyEapD3Jzn88Qafr7YMeta } from "/opt/buildhome/repo/pages/zapo/tools/system-options.vue?macro=true";
import { default as invoices0jbaaS63DtZeJf8FBUwvEumdRv0_45em9KnRe_45q_45mbPU0Meta } from "/opt/buildhome/repo/pages/customer/settings/invoices.vue?macro=true";
import { default as userspwNcs_453Z7txNVr965iGsIlt_45UqBK1Xc_45b3DFD7WTNTcMeta } from "/opt/buildhome/repo/pages/zapo/management/user/users.vue?macro=true";
import { default as cancellationsRYV3tckljUW8UFVk_45AksQeGiqmjqAb256J9iLFDlh9gMeta } from "/opt/buildhome/repo/pages/zapo/reports/cancellations.vue?macro=true";
import { default as sales_45metrics_457e3T7nZZJG_768vE4OWHw1CliK8lKW6p8tCRtdbbDkMeta } from "/opt/buildhome/repo/pages/zapo/reports/sales-metrics.vue?macro=true";
import { default as unknown_45calls8GXUsLG_45eXX4T_45N49lldxfW8rUv28PpU4FiPEMOtH7cMeta } from "/opt/buildhome/repo/pages/zapo/reports/unknown-calls.vue?macro=true";
import { default as crm_45usagerXOZrAU0Wlv3uFpTPWygldR20UxZPCZlluuMWiU9FXMMeta } from "/opt/buildhome/repo/pages/customer/settings/crm-usage.vue?macro=true";
import { default as subscriptiond8Hz2kNXrN1wsqicFiKX6FDIRp4ZzDTf_mS1Bi3GJ_8Meta } from "/opt/buildhome/repo/pages/customer/settings/subscription.vue?macro=true";
import { default as landing_45page_45editzcmhpQEzndWIEWtacPARfnCGt9Kn0hrAcM43p_Ti_XkMeta } from "/opt/buildhome/repo/pages/zapo/company/landing-page-edit.vue?macro=true";
import { default as search_45termskx7gsi8XRwmiXLrwFPjcfhlI0N6JZdtSBlF_2KCe_45kAMeta } from "/opt/buildhome/repo/pages/zapo/subscription/search-terms.vue?macro=true";
import { default as subscriptionnaMLDlJNERbO38mKC8nyg9dE6O9q0KiJi9S0y9G2QacMeta } from "/opt/buildhome/repo/pages/zapo/subscription/subscription.vue?macro=true";
import { default as configurationprue_45TgTjMoVTxmO7cKLP0dI5IoguVafEFpxY3aOmJoMeta } from "/opt/buildhome/repo/pages/customer/settings/configuration.vue?macro=true";
import { default as crm_45usage_45oldxOKZtlpw_pErby8Z_GYzHgWS0unWFpJ5ejSVhLdsC_45oMeta } from "/opt/buildhome/repo/pages/customer/settings/crm-usage-old.vue?macro=true";
import { default as notifications_5S9Z_Wkes7wLDaPSape7j2FrrB2jUkVuUhXeJxdAAEMeta } from "/opt/buildhome/repo/pages/customer/settings/notifications.vue?macro=true";
import { default as subscriptions2mTtGgbJFoVo_jcX_nMYr0XIFrRgsZjuLm5GVk_tlRsMeta } from "/opt/buildhome/repo/pages/customer/settings/subscriptions.vue?macro=true";
import { default as subscriptionsYc80SgetY1SS9Y6UoJJkN5liJXj1Tsn0cukLMIQdbMQMeta } from "/opt/buildhome/repo/pages/zapo/subscription/subscriptions.vue?macro=true";
import { default as payment_45methodstzjJ4_45UsJG2Rdaclda27YEiUmHVYIrtPCC4uuJvTPS4Meta } from "/opt/buildhome/repo/pages/customer/settings/payment-methods.vue?macro=true";
import { default as crm_45usage_45settingsPElBRlApce90Tc3lPXZy1YJyaRqA_45vmOTeakSG_45QJX0Meta } from "/opt/buildhome/repo/pages/customer/settings/crm-usage-settings.vue?macro=true";
export default [
  {
    name: "zapo-test",
    path: "/zapo/test",
    component: () => import("/opt/buildhome/repo/pages/zapo/test.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    component: () => import("/opt/buildhome/repo/pages/auth/login.vue")
  },
  {
    name: "auth-forgot",
    path: "/auth/forgot",
    component: () => import("/opt/buildhome/repo/pages/auth/forgot.vue")
  },
  {
    name: "auth-register",
    path: "/auth/register",
    component: () => import("/opt/buildhome/repo/pages/auth/register.vue")
  },
  {
    name: "customer-calls",
    path: "/customer/calls",
    component: () => import("/opt/buildhome/repo/pages/customer/calls.vue")
  },
  {
    name: "customer-inbox",
    path: "/customer/inbox",
    component: () => import("/opt/buildhome/repo/pages/customer/inbox.vue")
  },
  {
    name: "customer-leads",
    path: "/customer/leads",
    component: () => import("/opt/buildhome/repo/pages/customer/leads.vue")
  },
  {
    name: "customer-tasks",
    path: "/customer/tasks",
    component: () => import("/opt/buildhome/repo/pages/customer/tasks.vue")
  },
  {
    name: "sign-up-3-plan",
    path: "/sign-up/3-plan",
    component: () => import("/opt/buildhome/repo/pages/sign-up/3-plan.vue")
  },
  {
    name: "customer-events",
    path: "/customer/events",
    component: () => import("/opt/buildhome/repo/pages/customer/events.vue")
  },
  {
    name: "zapo-onboarding",
    path: "/zapo/onboarding",
    component: () => import("/opt/buildhome/repo/pages/zapo/onboarding.vue")
  },
  {
    name: "zapo-tools-user",
    path: "/zapo/tools/user",
    component: () => import("/opt/buildhome/repo/pages/zapo/tools/user.vue")
  },
  {
    name: "zapo-company-ads",
    path: "/zapo/company/ads",
    component: () => import("/opt/buildhome/repo/pages/zapo/company/ads.vue")
  },
  {
    name: "zapo-reports-mrr",
    path: "/zapo/reports/mrr",
    component: () => import("/opt/buildhome/repo/pages/zapo/reports/mrr.vue")
  },
  {
    name: "zapo-sales-leads",
    path: "/zapo/sales/leads",
    component: () => import("/opt/buildhome/repo/pages/zapo/sales/leads.vue")
  },
  {
    name: "zapo-tools-users",
    path: "/zapo/tools/users",
    component: () => import("/opt/buildhome/repo/pages/zapo/tools/users.vue")
  },
  {
    name: "customer-calendar",
    path: "/customer/calendar",
    component: () => import("/opt/buildhome/repo/pages/customer/calendar.vue")
  },
  {
    name: "sign-up-1-company",
    path: "/sign-up/1-company",
    component: () => import("/opt/buildhome/repo/pages/sign-up/1-company.vue")
  },
  {
    name: "sign-up-4-payment",
    path: "/sign-up/4-payment",
    component: () => import("/opt/buildhome/repo/pages/sign-up/4-payment.vue")
  },
  {
    name: "zapo-landing-page",
    path: "/zapo/landing-page",
    component: () => import("/opt/buildhome/repo/pages/zapo/landing-page.vue")
  },
  {
    name: "customer-deal-deal",
    path: "/customer/deal/deal",
    component: () => import("/opt/buildhome/repo/pages/customer/deal/deal.vue")
  },
  {
    name: "onboarding-4-build",
    path: "/onboarding/4-build",
    component: () => import("/opt/buildhome/repo/pages/onboarding/4-build.vue")
  },
  {
    name: "sign-up-2-location",
    path: "/sign-up/2-location",
    component: () => import("/opt/buildhome/repo/pages/sign-up/2-location.vue")
  },
  {
    name: "sign-up-5-complete",
    path: "/sign-up/5-complete",
    component: () => import("/opt/buildhome/repo/pages/sign-up/5-complete.vue")
  },
  {
    name: "zapo-company-about",
    path: "/zapo/company/about",
    component: () => import("/opt/buildhome/repo/pages/zapo/company/about.vue")
  },
  {
    name: "zapo-company-cards",
    path: "/zapo/company/cards",
    component: () => import("/opt/buildhome/repo/pages/zapo/company/cards.vue")
  },
  {
    name: "zapo-company",
    path: "/zapo/company",
    component: () => import("/opt/buildhome/repo/pages/zapo/company/index.vue")
  },
  {
    name: "zapo-reports-calls",
    path: "/zapo/reports/calls",
    component: () => import("/opt/buildhome/repo/pages/zapo/reports/calls.vue")
  },
  {
    name: "zapo-tools-domains",
    path: "/zapo/tools/domains",
    component: () => import("/opt/buildhome/repo/pages/zapo/tools/domains.vue")
  },
  {
    name: "customer-deal-deals",
    path: "/customer/deal/deals",
    component: () => import("/opt/buildhome/repo/pages/customer/deal/deals.vue")
  },
  {
    name: "onboarding-2-images",
    path: "/onboarding/2-images",
    component: () => import("/opt/buildhome/repo/pages/onboarding/2-images.vue")
  },
  {
    name: "onboarding-5-launch",
    path: "/onboarding/5-launch",
    component: () => import("/opt/buildhome/repo/pages/onboarding/5-launch.vue")
  },
  {
    name: "zapo-company-assets",
    path: "/zapo/company/assets",
    component: () => import("/opt/buildhome/repo/pages/zapo/company/assets.vue")
  },
  {
    name: "zapo-company-veriff",
    path: "/zapo/company/veriff",
    component: () => import("/opt/buildhome/repo/pages/zapo/company/veriff.vue")
  },
  {
    name: "zapo-company-company",
    path: "/zapo/company/company",
    component: () => import("/opt/buildhome/repo/pages/zapo/company/company.vue")
  },
  {
    name: "zapo-company-sign-up",
    path: "/zapo/company/sign-up",
    component: () => import("/opt/buildhome/repo/pages/zapo/company/sign-up.vue")
  },
  {
    name: "zapo-sales-prospects",
    path: "/zapo/sales/prospects",
    component: () => import("/opt/buildhome/repo/pages/zapo/sales/prospects.vue")
  },
  {
    name: "zapo-tools-locations",
    path: "/zapo/tools/locations",
    component: () => import("/opt/buildhome/repo/pages/zapo/tools/locations.vue")
  },
  {
    name: "auth-sms-verification",
    path: "/auth/sms-verification",
    component: () => import("/opt/buildhome/repo/pages/auth/sms-verification.vue")
  },
  {
    name: "onboarding-1-business",
    path: "/onboarding/1-business",
    component: () => import("/opt/buildhome/repo/pages/onboarding/1-business.vue")
  },
  {
    name: "zapo-company-invoices",
    path: "/zapo/company/invoices",
    component: () => import("/opt/buildhome/repo/pages/zapo/company/invoices.vue")
  },
  {
    name: "customer-notifications",
    path: "/customer/notifications",
    component: () => import("/opt/buildhome/repo/pages/customer/notifications.vue")
  },
  {
    name: "zapo-reports-lead-feed",
    path: "/zapo/reports/lead-feed",
    component: () => import("/opt/buildhome/repo/pages/zapo/reports/lead-feed.vue")
  },
  {
    name: "auth-email-verification",
    path: "/auth/email-verification",
    component: () => import("/opt/buildhome/repo/pages/auth/email-verification.vue")
  },
  {
    name: "customer-settings-users",
    path: "/customer/settings/users",
    component: () => import("/opt/buildhome/repo/pages/customer/settings/users.vue")
  },
  {
    name: "zapo-company-onboarding",
    path: "/zapo/company/onboarding",
    component: () => import("/opt/buildhome/repo/pages/zapo/company/onboarding.vue")
  },
  {
    name: "zapo-reports-commission",
    path: "/zapo/reports/commission",
    component: () => import("/opt/buildhome/repo/pages/zapo/reports/commission.vue")
  },
  {
    name: "zapo-reports-salesboard",
    path: "/zapo/reports/salesboard",
    component: () => import("/opt/buildhome/repo/pages/zapo/reports/salesboard.vue")
  },
  {
    name: "zapo-tools-lead-quality",
    path: "/zapo/tools/lead-quality",
    component: () => import("/opt/buildhome/repo/pages/zapo/tools/lead-quality.vue")
  },
  {
    name: "zapo-tools-search-terms",
    path: "/zapo/tools/search-terms",
    component: () => import("/opt/buildhome/repo/pages/zapo/tools/search-terms.vue")
  },
  {
    name: "customer-contact-contact",
    path: "/customer/contact/contact",
    component: () => import("/opt/buildhome/repo/pages/customer/contact/contact.vue")
  },
  {
    name: "customer-reporting-deals",
    path: "/customer/reporting/deals",
    component: () => import("/opt/buildhome/repo/pages/customer/reporting/deals.vue")
  },
  {
    name: "customer-reporting-leads",
    path: "/customer/reporting/leads",
    component: () => import("/opt/buildhome/repo/pages/customer/reporting/leads.vue")
  },
  {
    name: "zapo-company-performance",
    path: "/zapo/company/performance",
    component: () => import("/opt/buildhome/repo/pages/zapo/company/performance.vue")
  },
  {
    name: "zapo-reports-lead-volume",
    path: "/zapo/reports/lead-volume",
    component: () => import("/opt/buildhome/repo/pages/zapo/reports/lead-volume.vue")
  },
  {
    name: "zapo-tools-sms-templates",
    path: "/zapo/tools/sms-templates",
    component: () => import("/opt/buildhome/repo/pages/zapo/tools/sms-templates.vue")
  },
  {
    name: "customer-contact-contacts",
    path: "/customer/contact/contacts",
    component: () => import("/opt/buildhome/repo/pages/customer/contact/contacts.vue")
  },
  {
    name: "customer-settings-profile",
    path: "/customer/settings/profile",
    component: () => import("/opt/buildhome/repo/pages/customer/settings/profile.vue")
  },
  {
    name: "onboarding-3-verification",
    path: "/onboarding/3-verification",
    component: () => import("/opt/buildhome/repo/pages/onboarding/3-verification.vue")
  },
  {
    name: "zapo-company-landing-page",
    path: "/zapo/company/landing-page",
    component: () => import("/opt/buildhome/repo/pages/zapo/company/landing-page.vue")
  },
  {
    name: "zapo-management-user-user",
    path: "/zapo/management/user/user",
    component: () => import("/opt/buildhome/repo/pages/zapo/management/user/user.vue")
  },
  {
    name: "zapo-tools-system-options",
    path: "/zapo/tools/system-options",
    component: () => import("/opt/buildhome/repo/pages/zapo/tools/system-options.vue")
  },
  {
    name: "customer-settings-invoices",
    path: "/customer/settings/invoices",
    component: () => import("/opt/buildhome/repo/pages/customer/settings/invoices.vue")
  },
  {
    name: "zapo-management-user-users",
    path: "/zapo/management/user/users",
    component: () => import("/opt/buildhome/repo/pages/zapo/management/user/users.vue")
  },
  {
    name: "zapo-reports-cancellations",
    path: "/zapo/reports/cancellations",
    component: () => import("/opt/buildhome/repo/pages/zapo/reports/cancellations.vue")
  },
  {
    name: "zapo-reports-sales-metrics",
    path: "/zapo/reports/sales-metrics",
    component: () => import("/opt/buildhome/repo/pages/zapo/reports/sales-metrics.vue")
  },
  {
    name: "zapo-reports-unknown-calls",
    path: "/zapo/reports/unknown-calls",
    component: () => import("/opt/buildhome/repo/pages/zapo/reports/unknown-calls.vue")
  },
  {
    name: "customer-settings-crm-usage",
    path: "/customer/settings/crm-usage",
    component: () => import("/opt/buildhome/repo/pages/customer/settings/crm-usage.vue")
  },
  {
    name: "customer-settings-subscription",
    path: "/customer/settings/subscription",
    component: () => import("/opt/buildhome/repo/pages/customer/settings/subscription.vue")
  },
  {
    name: "zapo-company-landing-page-edit",
    path: "/zapo/company/landing-page-edit",
    component: () => import("/opt/buildhome/repo/pages/zapo/company/landing-page-edit.vue")
  },
  {
    name: "zapo-subscription-search-terms",
    path: "/zapo/subscription/search-terms",
    component: () => import("/opt/buildhome/repo/pages/zapo/subscription/search-terms.vue")
  },
  {
    name: "zapo-subscription-subscription",
    path: "/zapo/subscription/subscription",
    component: () => import("/opt/buildhome/repo/pages/zapo/subscription/subscription.vue")
  },
  {
    name: "customer-settings-configuration",
    path: "/customer/settings/configuration",
    component: () => import("/opt/buildhome/repo/pages/customer/settings/configuration.vue")
  },
  {
    name: "customer-settings-crm-usage-old",
    path: "/customer/settings/crm-usage-old",
    component: () => import("/opt/buildhome/repo/pages/customer/settings/crm-usage-old.vue")
  },
  {
    name: "customer-settings-notifications",
    path: "/customer/settings/notifications",
    component: () => import("/opt/buildhome/repo/pages/customer/settings/notifications.vue")
  },
  {
    name: "customer-settings-subscriptions",
    path: "/customer/settings/subscriptions",
    component: () => import("/opt/buildhome/repo/pages/customer/settings/subscriptions.vue")
  },
  {
    name: "zapo-subscription-subscriptions",
    path: "/zapo/subscription/subscriptions",
    component: () => import("/opt/buildhome/repo/pages/zapo/subscription/subscriptions.vue")
  },
  {
    name: "customer-settings-payment-methods",
    path: "/customer/settings/payment-methods",
    component: () => import("/opt/buildhome/repo/pages/customer/settings/payment-methods.vue")
  },
  {
    name: "customer-settings-crm-usage-settings",
    path: "/customer/settings/crm-usage-settings",
    component: () => import("/opt/buildhome/repo/pages/customer/settings/crm-usage-settings.vue")
  }
]